import React from 'react';
import Footer from '../Shared/Footer/Footer';
import Navigation from '../Shared/Navigation/Navigation';

const Contact = () => {
	return (
		<div>
			<Navigation />
			<h1>BikeBD</h1>
			<p>	Suite 222(2nd Floor), Sheltec Sierra Computer City, 236 New Elephant Rd, Dhaka 1205</p>
			<Footer />
		</div>
	);
};

export default Contact;